var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUserMenuNotifications(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "30px",
    height: "30px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#231F20",
    d: "M26.585,21.184c-2.332-2.018-4.492-4.865-4.492-11.973c0-4.117-3.35-7.467-7.465-7.467 c-4.119,0-7.468,3.35-7.468,7.467c0,7.115-2.158,9.959-4.494,11.975c-0.647,0.564-1.019,1.377-1.019,2.229 c0,0.469,0.38,0.85,0.85,0.85h8.06c0.394,1.887,2.068,3.309,4.07,3.309c2.002,0,3.678-1.422,4.07-3.309h8.061 c0.469,0,0.85-0.381,0.85-0.85C27.606,22.555,27.233,21.742,26.585,21.184z M14.626,25.873c-1.057,0-1.96-0.67-2.307-1.609h4.616 C16.589,25.203,15.685,25.873,14.626,25.873z M3.68,22.564c0.031-0.033,0.063-0.064,0.099-0.096c3.561-3.074,5.08-7.039,5.08-13.258 c0-3.181,2.587-5.768,5.767-5.768c3.182,0,5.768,2.587,5.768,5.768c0,6.213,1.52,10.178,5.082,13.26 c0.035,0.029,0.068,0.061,0.1,0.094H3.68z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserMenuNotifications);
export default __webpack_public_path__ + "static/media/user_menu_notifications.4fda2f3231540a2c6eb29b1788a14ec7.svg";
export { ForwardRef as ReactComponent };